import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton'
import LoginStore from '../stores/LoginStore'
import { observer } from 'mobx-react';
// import uuid from 'uuid';
import ActionHome from 'material-ui/svg-icons/action/home';
import IconButton from 'material-ui/IconButton';
import Dialog from '../components/Dialog.js';
import myFunctions from '../stores/myFunctions.js';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import _ from 'lodash';
// import CryptoJS from 'crypto-js';
import { saveID, loadID } from '../util/idCrypto'
import { urlParam } from '../util/urlParam'

// let captcha_uuid = ''
let phone_service_url = '/public/phone_service'

// const add_img = `https://captcha.kfsyscc.org/ca/captcha.jpg`

class Login extends Component {
	constructor() {
		super()

		this.handleSendSmsCode = this.handleSendSmsCode.bind(this)
		this.handleCheckSmsCode = this.handleCheckSmsCode.bind(this)
		this.onCaptchaChange = this.onCaptchaChange.bind(this)
		this.handleAccountChange = this.handleAccountChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleSmsCodeChange = this.handleSmsCodeChange.bind(this);
		this.goTelReg = this.goTelReg.bind(this)
		this.handleIDChange = this.handleIDChange.bind(this)
		this.goBack = this.goBack.bind(this)
	}

	goBack() {
		history.back()
	}

	componentDidMount() {
		this.getCaptcha()

		// // get local storage
		// if (LoginStore.id === '') {
		// 	LoginStore.id = loadID()
		// } else {
		// 	return false
		// }
	}

	goTelReg() {
		location.href = phone_service_url
	}

	handleIDChange(e, value) {
		LoginStore.id = value.toUpperCase();
	}

	handleAccountChange(e, value) {
		LoginStore.account = value;
	}

	handlePasswordChange(e, value) {
		LoginStore.password = value;
	}

	handleSmsCodeChange(e, value) {
		LoginStore.smscode = value;
	}

	handleSendSmsCode() {
		LoginStore.sendSmsCode();
		saveID(LoginStore.id)
	}

	handleCheckSmsCode() {
		LoginStore.checkSmsCode();
		saveID(LoginStore.id)
	}

	getCaptcha() {
		LoginStore.input_veridation_code = '';

		var myImage = document.querySelector('img');

		if (myImage !== null) {
			const fetchGetConfig = {
				method: 'GET',
				credentials: 'include'
			}
			var imageUrl = `https://captcha.kfsyscc.org/ca/captcha.jpg`
			fetch(imageUrl, fetchGetConfig).then((res) => {
				return res.blob()
			}).then((res) => {
				var objcetURL = URL.createObjectURL(res)
				myImage.src = objcetURL
				// console.log(myImage.src);
				// this.getDigits()
				// console.log(myRequest)
				fetch(`https://captcha.kfsyscc.org/ca/digits`, fetchGetConfig).then((res) => {
					return res.json()
				}).then((data) => {
					// console.log('得到答案:', data.digit);
					LoginStore.veridation_code = data.digit;
				})
			})
		}
	}

	onCaptchaChange(event) {
		LoginStore.input_veridation_code = event.target.value;

	}

	render() {
		return (
			<div style={{ maxWidth: '435px', margin: '0 auto', backgroundColor: 'white', height: '100vh', overflow: 'auto' }}>
				{
					urlParam(window.location.href).app === 'true' ? null :
						<AppBar
							title={<div>登入者驗證<span style={{ fontSize: '11px' }}>{myFunctions.version}</span></div>}
							style={{ backgroundColor: 'white', textAlign: 'center' }}
							titleStyle={{ color: "black" }}
							iconElementLeft={<ChevronLeft style={{ marginTop: '11px' }} />}
							onLeftIconButtonTouchTap={this.goBack}
							iconElementRight={<IconButton iconStyle={{ fill: 'black' }}><ActionHome onClick={() => { location.href = "/m/" }} /></IconButton>}
						/>
				}
				{
					LoginStore.SmsView === false ?
						<div style={{ padding: '10px' }}>
							<TextField
								hintText=""
								floatingLabelText="帳號：身分證字號/居留證號碼"
								floatingLabelFixed={true}
								fullWidth={true}
								onChange={this.handleIDChange}
								value={LoginStore.id}
								ref={(input) => { this.textInput = input; }}
							/><br />
							<TextField
								hintText=""
								floatingLabelText="密碼"
								floatingLabelFixed={true}
								type="password"
								fullWidth={true}
								onChange={this.handlePasswordChange}
								value={LoginStore.password}
							/><br />
							<div>
								<TextField
									hintText=""
									floatingLabelText="圖形驗證碼"
									floatingLabelFixed={true}
									onChange={this.onCaptchaChange}
									style={{ width: '40%' }}
									value={LoginStore.input_veridation_code}
									type="number"
									inputStyle={{ fontFamily: 'Noto Sans TC', letterSpacing: '1px' }}
								/>
								<img src=''
									onClick={this.getCaptcha}
									style={{ marginRight: '0px', paddingRight: '0px' }}
									alt="驗證碼"
								/>
								<i className="fa fa-refresh"
									aria-hidden="true"
									style={{ padding: '0 50px', color: 'rgb(100,181,246)' }}
									onClick={this.getCaptcha}
								/>
							</div>
							<div style={{ marginBottom: '10px' }}>
								{
									urlParam(window.location.href).app === 'true'
										? <span style={{ marginRight: '15px' }}>
											<FlatButton
												label="申請密碼"
												primary={true}
												onClick={() => {
													window.postMessage('open_new_account_page')
												}}
											/>
										</span>
										: <span style={{ marginRight: '15px' }}>
											<FlatButton
												label="申請密碼"
												primary={true}
												onClick={() => {
													location.href = '/public/new_account'
												}}
											/>
										</span>
								}
								{
									urlParam(window.location.href).app === 'true'
										? <span>
											<FlatButton
												label="忘記密碼"
												primary={true}
												onClick={() => {
													window.postMessage('open_forget_password_page')
												}}
											/>
										</span>
										: <span>
											<FlatButton
												label="忘記密碼"
												primary={true}
												onClick={() => {
													location.href = '/public/reset_password'
												}}
											/>
										</span>
								}

							</div>

							<div className={'card-1 card'} style={{ left: '0px' }}>
								<div>您將閱讀隱私資料，為確保資訊安全，請再次驗證。</div>
							</div>

							<div style={{ marginBottom: '10px' }}>
								<RaisedButton label="傳送簡訊驗證碼" primary={true} onClick={this.handleSendSmsCode} />
							</div>
						</div>
						:
						<div style={{ textAlign: "center" }}>
							<TextField
								floatingLabelText="簡訊驗證碼"
								floatingLabelFixed={true}
								onChange={this.handleSmsCodeChange}
								value={LoginStore.smscode}
								style={{ margin: 50 }}
							/>
							<br />
							<RaisedButton label="驗證" primary={true} onClick={this.handleCheckSmsCode} />
						</div>
				}
				<Dialog />
			</div>
		);
	}
}

export default observer(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js